import "./IconList.scss"

export default (props) => {
  const layout = props.layout ? props.layout : "horizontal";
  const cls = props.className ? props.className : "horizontal";
  const align = props.align ? props.align : "default";

  return <div className={`Icon-list Icon-list_layout_${layout} ${cls} Icon-list_align_${align}`}>{props.children}</div>;
};
